import { action, observable } from "mobx";

import { localizationService } from "@state";
import type { RootStore } from "@state/stores/types";

class WalletGracePeriodPopupStore {
	@observable isActive: boolean = false;
	@observable infoMessage: string | null = null;
	rootStore: RootStore;

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore;
	}

	@action.bound
	showPopup(gracePeriodExpirationDate?: string | null) {
		this.isActive = true;
		if (gracePeriodExpirationDate) {
			this.rootStore.userAuthStore.setWalletGracePeriod(
				gracePeriodExpirationDate
			);
		}
	}

	@action.bound
	hidePopup() {
		this.isActive = false;
		this.setMessage(null);
	}

	@action.bound
	setMessage(msg: string | null) {
		this.infoMessage = msg;
	}

	async checkUserMatchingStatus(userStatus: {
		offlineUserAccountsDeactivated: boolean;
		onlineUserAccountDeactivated: boolean;
		userAccountDeactivationGracePeriodExpirationDate: string | null;
	}) {
		await localizationService.loadNamespaces("wallet-grace-period");

		if (userStatus.offlineUserAccountsDeactivated) {
			this.rootStore.notificationStore.warning(
				localizationService.t(
					"wallet-grace-period:OFFLINE_ACCOUNTS_DEACTIVATED"
				)
			);
		}
		if (userStatus.onlineUserAccountDeactivated) {
			this.rootStore.notificationStore.warning(
				localizationService.t(
					"wallet-grace-period:ONLINE_ACCOUNT_DEACTIVATED"
				)
			);
		}
		if (userStatus.userAccountDeactivationGracePeriodExpirationDate) {
			this.rootStore.userAuthStore.setWalletGracePeriod(
				userStatus.userAccountDeactivationGracePeriodExpirationDate
			);
		}
	}
}

export default WalletGracePeriodPopupStore;
